import React from "react";

export const Chat = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path d="M24,11.247A12.012,12.012,0,1,0,12.017,24H19a5.005,5.005,0,0,0,5-5V11.247ZM22,19a3,3,0,0,1-3,3H12.017a10.041,10.041,0,0,1-7.476-3.343,9.917,9.917,0,0,1-2.476-7.814,10.043,10.043,0,0,1,8.656-8.761A10.564,10.564,0,0,1,12.021,2,9.921,9.921,0,0,1,18.4,4.3,10.041,10.041,0,0,1,22,11.342Z"/>
        <path d="M8,9h4a1,1,0,0,0,0-2H8A1,1,0,0,0,8,9Z"/>
        <path d="M16,11H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"/>
        <path d="M16,15H8a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"/>
    </svg>
)